import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import DataVVue3 from '@kjgl77/datav-vue3'
import './assets/scss/style.scss'
import './assets/icon/iconfont.css'
import '@/common/echart/map/fujian.js'
import PublicComponent from '@/components/componentInstall'
import * as echarts from 'echarts'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
console.log('getMap 福建 on boot', ((window as any).echarts || echarts).getMap('福建'))
// 引入所有图标样式
import '@fortawesome/fontawesome-free/css/all.css'

const app = createApp(App)
app.use(PublicComponent)
app.use(ElementPlus)
app.use(DataVVue3)
app.use(store)
app.use(router)
app.mount('#app')
